import { render } from "./ConfigGrupo.vue?vue&type=template&id=650bf505&scoped=true&ts=true"
import script from "./ConfigGrupo.vue?vue&type=script&lang=ts"
export * from "./ConfigGrupo.vue?vue&type=script&lang=ts"

import "./ConfigGrupo.vue?vue&type=style&index=0&id=650bf505&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650bf505"]])

export default __exports__